
import { FastField, useFormikContext } from 'formik';
import useSWR from 'swr';
import { Grid, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
// import { statesList } from '@shared/constants/statesList';
import { CheckboxField } from '@shared/fields/CheckboxField';
// import { PhoneInputField } from '@shared/fields/PhoneInputField';
import { useQueryState } from '@shared/hooks/useQueryState';
import { SERVICES } from '@shared/constants/apiConfig';
import { BoxWraper } from '@styles/StyledDiv';
import { IStip, IStipReviewFormProps } from '../interfaces';
import { IAsset} from '../../Assets/interfaces';
import { NContact } from '../../Contact/validation';
import { ICoApplicant } from '../../Contact/components/CoApplicant/validation';
import { getFieldCompareStatus, getFields} from './helper';

export const StipReviewForm = ({ stipReview }: IStipReviewFormProps) => {
  const [contactIdParam] = useQueryState('id');
  const [assetIdParam] = useQueryState('assetId');
  const { values } = useFormikContext<IStip>();
  const { 
    data: contactData, error: contactError
  } = useSWR<NContact.Entity>(
    contactIdParam && `/${SERVICES.CONTACT}/contacts/${contactIdParam}`
  );
  const { data: assetData, error: assetError } = useSWR<IAsset>(assetIdParam && `${SERVICES.ASSET}/assets/${assetIdParam}`);

  const {
    data: coApplicant,
    error: coApplicantError
  } = useSWR<ICoApplicant>(
    contactIdParam && contactData?.coApplicants?.[0]?.id && `/${SERVICES.CONTACT}/contacts/${contactIdParam}/co-applicants/${contactData.coApplicants[0].id}`
  );
  
  const renderFields = <T extends object>(fieldsList: IFormFieldConfig<T>[]) => {
    const isAssetLoading = Boolean(assetIdParam && !assetData);
    const isCoApplicantLoading = Boolean(contactData?.coApplicants?.length && !coApplicant);

    if (!contactData || isAssetLoading || isCoApplicantLoading) return null;

    return fieldsList.map(({ name, label, component, checkboxName, variant, compareWith, ...rest }) => {
      const status = getFieldCompareStatus(name, compareWith, values, contactData, assetData, coApplicant);

      return (
        <Grid 
        key={label}
        container
        mt={1}
      >
        <Grid
          item
          md={5}
          pt={1}
        >
          <Typography variant={variant as Variant}>{label}</Typography>
        </Grid>

        <Grid
          item
          md={7}
        >
          <Grid
            container
            pt={0}
          >
            <Grid
              item
              md={2}
            >
              {(checkboxName as string) && (
                <FastField
                  name={checkboxName}
                  component={CheckboxField}
                />
              )}
            </Grid>

            <Grid
              item
              md={10}
            >
              <FastField
                {...rest}
                // width="100%"
                name={name}
                component={component}
                compareStatus={status}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      );
    });
  };
  if (contactError || assetError || coApplicantError) return null;
  const fields = getFields({stipReview});
  return <BoxWraper>{stipReview?.stipTypeId && renderFields(fields)}</BoxWraper>;
};
